import { render, staticRenderFns } from "./FContractDetail.vue?vue&type=template&id=2104f2c8&"
import script from "./FContractDetail.vue?vue&type=script&lang=js&"
export * from "./FContractDetail.vue?vue&type=script&lang=js&"
import style0 from "./FContractDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports